export default __webpack_public_path__ + "static/media/icons.2478ec89.png";